export default __webpack_public_path__ + "static/museo-sans-regular-ffc7240944355d9a5ee6a9ec30c23b65.woff2";